import React, { useState } from "react";
import CourtSeriesKeptReport from "../../reservas/components/CourtSeriesKeptReport";
import { seriesDateLabel, shortSeriesDate } from "../../reservas/components/courtSeriesModel";
import { nombreCliente } from "./agendaLayout";
import { KEPT_LABELS, intervalPhrase } from "./turnoFijoModel";
import "../../reservas/reservas-organizer.css";
import "../../primerUso/primerUso.css";
import "./agenda.css";

/* ─────────────────────────────────────────
   Cancelar un turno que es parte de un turno fijo: "Solo este turno" (la cancelación de siempre) o
   "Este y los siguientes" (POST /series/:id/cancel desde esta fecha). AgendaTab resuelve las llamadas.
───────────────────────────────────────── */

const OPCIONES = ["solo", "siguientes"];

export function CancelarSerieModal({ turno, fecha, busy = false, onSolo, onSiguientes, onVolver }) {
  const [eleccion, setEleccion] = useState("solo");
  const serie = turno.series;
  const con = turno.professionalName ? ` con ${turno.professionalName}` : "";
  const detalle = {
    solo: `${seriesDateLabel(fecha)}, ${turno.slotStart || serie.slotStart}. Los demás siguen igual.`,
    siguientes: `Hasta el ${shortSeriesDate(serie.dateTo)}. Los ya cobrados o con ingreso se mantienen.`,
  };
  const titulos = { solo: "Solo este turno", siguientes: "Este y los siguientes" };

  return (
    <div className="zr-overlay" onMouseDown={busy ? undefined : onVolver}>
      <div className="zr-modal" role="dialog" aria-modal="true" aria-labelledby="cancelar-serie-title" onMouseDown={(e) => e.stopPropagation()}>
        <h3 id="cancelar-serie-title" className="zr-modal__title">Cancelar turno fijo</h3>
        <p className="zr-modal__text">
          {nombreCliente(turno)} tiene este turno {intervalPhrase(serie.intervalWeeks)}
          {con}.
        </p>
        <div className="zr-choice" role="radiogroup" aria-label="Qué cancelar">
          {OPCIONES.map((op) => (
            <button
              key={op}
              type="button"
              className="pu-mode"
              role="radio"
              aria-checked={eleccion === op}
              aria-pressed={eleccion === op}
              disabled={busy}
              onClick={() => setEleccion(op)}
            >
              <span className={`zr-radio${eleccion === op ? " is-on" : ""}`} aria-hidden="true" />
              <span>
                <strong>{titulos[op]}</strong>
                <span>{detalle[op]}</span>
              </span>
            </button>
          ))}
        </div>
        <div className="zr-modal__actions">
          <button type="button" className="zr-btn zr-btn--ghost" onClick={onVolver} disabled={busy}>Volver</button>
          <button type="button" className="zr-btn zr-btn--dark" onClick={() => (eleccion === "solo" ? onSolo() : onSiguientes())} disabled={busy}>
            {busy ? "Cancelando..." : "Cancelar turno"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* Lo que quedó en pie después de "Este y los siguientes": fechas ya cobradas o con ingreso. */
export function FechasMantenidasModal({ resultado, onClose }) {
  return (
    <div className="zr-overlay" onMouseDown={onClose}>
      <div className="zr-modal" role="dialog" aria-modal="true" aria-label="Fechas que se mantuvieron" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="zr-modal__title">Turno fijo cancelado</h3>
        <p className="zr-modal__text">Algunas fechas no se cancelaron porque ya tienen un cobro o un ingreso.</p>
        <CourtSeriesKeptReport kept={resultado.kept} reasonLabels={KEPT_LABELS} />
        <div className="zr-modal__actions">
          <button type="button" className="zr-btn zr-btn--dark" onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
